import { clambersSignature } from './data';
import type { ClambersPuzzle } from './types';

export type ClambersSubmission =
  | { kind: 'incomplete' }
  | { kind: 'wrong-letters' }
  | { kind: 'not-accepted' }
  | { kind: 'accepted'; answer: string };

export function evaluateClambersSubmission(
  guess: string,
  puzzle: ClambersPuzzle,
): ClambersSubmission {
  const normalized = guess.toLowerCase();
  if (normalized.length !== 6) return { kind: 'incomplete' };
  if (clambersSignature(normalized) !== clambersSignature(puzzle.letterOrder)) {
    return { kind: 'wrong-letters' };
  }
  if (!puzzle.acceptedAnswers.includes(normalized)) return { kind: 'not-accepted' };
  return { kind: 'accepted', answer: normalized };
}

export function getClambersCompletionDelta(hasPenalty: boolean): number {
  return hasPenalty ? 0 : -8_000;
}
